var publicPath = __webpack_public_path__;
                    var symbolUrl = 'svg/global.1d1faab74c5a9e7df7ed62ff2056061b.svg#social-facebook';
                    var viewUrl = 'svg/global.1d1faab74c5a9e7df7ed62ff2056061b.svg#view-social-facebook';

                    
                        var addCacheBust = typeof document !== 'undefined' && document.readyState === 'complete';
    
                        if (addCacheBust) {
                            symbolUrl = 'svg/global.1d1faab74c5a9e7df7ed62ff2056061b.svg?social-facebook#social-facebook';
                            viewUrl = 'svg/global.1d1faab74c5a9e7df7ed62ff2056061b.svg?social-facebook#view-social-facebook';
                        }
                    

                    module.exports = {
                        symbol: publicPath + symbolUrl,
                        view: publicPath + viewUrl,
                        viewBox: '0 0 14 15',
                        title: '',
                        toString: function () {
                            return JSON.stringify(this.view);
                        }
                    };